import { Result } from '../models/result';

export interface BuyerRepresentationResultMessage {
  title: string;
  text: string;
}

//result codes returned by uspInsertBuyerRepresentation, 0 = success
const failureMessages: { [code: number]: BuyerRepresentationResultMessage } = {
  1: { title: 'Account not verified', text: 'Your agent account needs to be verified by us before you can represent a buyer.' },
  2: { title: 'Buyer does not exist', text: 'The buyer you like to represent does not have an account with us. Please verify the buyers username and make sure the buyer has an account.' },
  3: { title: 'Already represented', text: 'The buyer is already represented by an agent on this property.' },
  4: { title: 'Conflict of interest', text: 'You already placed a bid/offer on this property and therefor cannot represent a buyer.' },
  5: { title: 'User not available', text: 'The username entered is registered as an agent and therefore not available for representation.' },
};

const successMessage: BuyerRepresentationResultMessage = {
  title: 'Representation request successful',
  text: 'The buyer and you will receive an email about this request. The buyer has to confirm your request within 48 hours or your request will be removed from the system.'
};

const errorMessage: BuyerRepresentationResultMessage = { title: 'Error', text: 'An error occured, try again later' };

export function buyerRepresentationResultMessage(result: Result): BuyerRepresentationResultMessage {
  //check success first: failed requests without a procedure result (exception, invalid business) also carry code 0
  if (result.success) return successMessage;
  return (result.code != null && failureMessages[result.code]) || errorMessage;
}
